import { jwtDecode } from 'jwt-decode';

const INITIAL_STATE = {
  user: null,
  tokenId: null,
  refreshToken: null
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'LOGIN':

    const decoded = jwtDecode(action.dados.tokenId);
    var role = decoded.role;

    console.log('role', role);

      return { ...state, ...action.dados, role };
    case 'LOGOUT':
      return { ...INITIAL_STATE };
    default:
      return state;
  }
};